export const mockMatches = [
  {
    id: "1",
    league: "英超",
    round: 11,
    homeTeam: { name: "曼城", logo: "", score: "2" },
    awayTeam: { name: "利物浦", logo: "", score: "1" },
    time: "20:00",
    status: "live",
  },
  {
    id: "2",
    league: "西甲",
    round: 11,
    homeTeam: { name: "皇马", logo: "", score: "3" },
    awayTeam: { name: "巴萨", logo: "", score: "2" },
    time: "22:00",
    status: "upcoming",
  },
  {
    id: "3",
    league: "德甲",
    round: 10,
    homeTeam: { name: "拜仁", logo: "", score: "4" },
    awayTeam: { name: "多特", logo: "", score: "0" },
    time: "19:30",
    status: "finished",
  },
  {
    id: "4",
    league: "意甲",
    round: 12,
    homeTeam: { name: "AC米兰", logo: "", score: "1" },
    awayTeam: { name: "国际米兰", logo: "", score: "1" },
    time: "21:00",
    status: "live",
  },
  {
    id: "5",
    league: "法甲",
    round: 11,
    homeTeam: { name: "巴黎", logo: "", score: "2" },
    awayTeam: { name: "马赛", logo: "", score: "1" },
    time: "23:00",
    status: "upcoming",
  },
];

export const mockHotLives = [
  {
    id: "1",
    title: "大帝",
    description: "足篮球彩分析推荐",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/d7fa6344bde5949e50447ab4a71c46e5.png",
    badge: "乐球直播",
    viewers: "1.04",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "2",
    title: "站长",
    description: "职业足球解说员",
    thumbnail:
      "https://lqcos.beijxs.com/2025-05-13/586c0b9a18a1a3aebe4c3ce5ab06a02e.jpg",
    badge: "乐球直播",
    viewers: "1.00",
    match: "塞那乔其 VS 古比斯",
    category: "芬超",
  },
  {
    id: "3",
    title: "雨哥电竞",
    description: "要玩电竞就跟雨哥!",
    thumbnail:
      "https://lqcos.beijxs.com/2025-11-14/b72d56303f37c4a1f52857f59b9a1d8d.png",
    badge: "乐球直播",
    viewers: "1.11",
    match: "哈萨征服 VS 利雅得体育",
    category: "沙王冠",
  },
  {
    id: "4",
    title: "清扬说球",
    description: "深耕足球领域二十余载",
    thumbnail:
      "https://lqcos.beijxs.com/2024-12-16/274cd25d6bc92f0fb9139f682dac1335.jpg",
    badge: "乐球直播",
    viewers: "1.10",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
  {
    id: "5",
    title: "怡宝",
    description: "足篮球女主播",
    thumbnail:
      "https://lqcos.beijxs.com/2025-03-31/baf458a5e8972e17c161fb1bfdf15a1f.JPG",
    badge: "乐球直播",
    viewers: "1.05",
    match: "史莫哈 VS 艾尔格纳",
    category: "埃及超",
  },
];

export const mockChannels = [
  {
    id: "1",
    title: "CCTV-5 体育",
    description: "中央电视台体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
  {
    id: "2",
    title: "广东体育",
    description: "广东电视台体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
  {
    id: "3",
    title: "五星体育",
    description: "上海五星体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
  {
    id: "4",
    title: "北京体育",
    description: "北京电视台体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
  {
    id: "5",
    title: "ESPN",
    description: "ESPN体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
  {
    id: "6",
    title: "Fox Sports",
    description: "Fox体育频道",
    src: "",
    poster: "/indexbg.png",
    type: "live",
    tags: ["体育", "直播"],
  },
];

export const mockScheduleLiveMatches = [
  {
    id: "1",
    league: "德戊",
    time: "21:30",
    status: "下半场 99'",
    homeTeam: "FV埃珀尔博恩",
    score: "4-1",
    awayTeam: "沃尔姆斯",
    halfBall: "4-1",
    corners: "0-0",
    trend: "0.85 3.5 0.84",
    isLive: true,
    liveStatus: "直播中山",
  },
  {
    id: "2",
    league: "德戊",
    time: "21:30",
    status: "下半场 99'",
    homeTeam: "FV埃珀尔博恩",
    score: "4-1",
    awayTeam: "沃尔姆斯",
    halfBall: "4-1",
    corners: "0-0",
    trend: "0.85 3.5 0.84",
    isLive: true,
    liveStatus: "直播中山",
  },
  {
    id: "3",
    league: "德戊",
    time: "21:30",
    status: "下半场 99'",
    homeTeam: "FV埃珀尔博恩",
    score: "4-1",
    awayTeam: "沃尔姆斯",
    halfBall: "4-1",
    corners: "0-0",
    trend: "0.85 3.5 0.84",
    isLive: false,
    liveStatus: "未开播",
  },
];

export const mockScheduleUpcomingMatches = [
  {
    id: "4",
    league: "西协丙",
    time: "21:30",
    status: "未开赛",
    homeTeam: "FV埃珀尔博恩",
    awayTeam: "沃尔姆斯",
    trend: "0.85 3.5 0.84",
    liveStatus: "未开赛",
  },
  {
    id: "5",
    league: "德戊",
    time: "21:30",
    status: "-未开赛-",
    homeTeam: "FV埃珀尔博恩",
    awayTeam: "沃尔姆斯",
    trend: "0.85 3.5 0.84",
    liveStatus: "未开赛",
  },
  {
    id: "6",
    league: "西协丙",
    time: "21:30",
    status: "未开赛",
    homeTeam: "FV埃珀尔博恩",
    awayTeam: "沃尔姆斯",
    trend: "0.85 3.5 0.84",
    liveStatus: "未开赛",
  },
];
